import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AanwerfSimulator } from '../models/AanwerfSimulator';
import { DataService } from './data.service';
import { ToastComponent } from '../shared/toast/toast.component';
@Injectable({
  providedIn: 'root'
})
export class AanwerfSimulatorService {
  aanwerfSimulatorDoc: AngularFirestoreDocument<AanwerfSimulator>;
  constructor(private firestore: AngularFirestore, public dataService: DataService,public toastComponent: ToastComponent) {this.toastComponent = toastComponent }
  aanwerfSimulator: AanwerfSimulator = {
    bedrijfsVoorheffing: 0,
    extraBasisBerekeningRSZ: 0,
    extraForfaitPerDag:0,
    extraForfaitPerUur:0,
    extraRSZWerkgever: 0,
    flexiRSZWerkgever: 0,
    fondsHorecaPercentage: 0,
    jaarlijkseVakantie: 0,
    studentRSZWerkgever: 0,
    studentRSZWerknemer: 0,
    tekstBasisUurloon: "Bij flexi job inclusief vakantiegeld dd",
    tekstBrutoUurloon: "Het minimum uurloon bedraagt voor een student  11,9293 €,voor een flexi-job 10,08 €, voor een extra 11,9293 €, voor een  gewone werknemer 11,9293 €.",
    tekstFondsHoreca: "Er is pas recht op een effectieve ddeindejaarspremie wanneer de werknemer minstens twee maanden ononderbroken in dienst was of wanneer de gelegenheidswerknemer minstens 44 dagen gewerkt heeft. ",
    werkbonusBovengrensLuikA: 0,
    werkbonusFactorLuikA: 0,
    werkbonusOndergrensLuikA: 0,
    werkbonusMinimumLuikA: 0,
    werkbonusBovengrensLuikB: 0,
    werkbonusFactorLuikB:0,
    werkbonusOndergrensLuikB: 0,
    werkbonusMinimumLuikB:0,
    werkbonusdagen: 0,
    werknemerRSZWerkgever: 0,
  }
  getAanwerfSimulator(id:string): Observable<AanwerfSimulator>
  {
    return this.firestore.collection("AanwerfSimulator").doc<AanwerfSimulator>(id).get().pipe(take(1),
      map(queryResult => {
        if(queryResult.exists){

          const data = queryResult.data() as AanwerfSimulator;
          const id = queryResult.id;
          this.dataService.aanwerfSimulator = data;
          return {id, ...data};
        }
        else{
          return null;
        }
      }));
  }
  async addAanwerfSimulator()
  {
    let aanwerfSimulatorId = '';
    await this.firestore.collection("AanwerfSimulator").add(this.aanwerfSimulator).then(function(docRef){
      aanwerfSimulatorId = docRef.id
    })
    return aanwerfSimulatorId;
  }
//Deze methode wordt alleen gebruikt wanneer de priveAdmin een nieuwe onderneming aanmaakt.
 updateNaToevoegen(id: string, ondernemingId:string, ondernemingNaam:string)
{
  this.aanwerfSimulator.ondernemingId = ondernemingId;
  this.aanwerfSimulator.ondernemingNaam = ondernemingNaam;
   this.aanwerfSimulator.id = id;
   this.updateAanwerfSimulator(this.aanwerfSimulator);
}

  async updateAanwerfSimulator(aanwerfSimulator: AanwerfSimulator) {
    try {
      this.aanwerfSimulatorDoc = this.firestore.doc(`AanwerfSimulator/${aanwerfSimulator.id}`);
      await this.aanwerfSimulatorDoc.update(aanwerfSimulator);
      this.dataService.aanwerfSimulator = aanwerfSimulator;
      this.toastComponent.showSuccess();
    } catch (err) {
      console.log(err);
    }
  }
  deleteAanwerfSimulator(id: string){
    this.aanwerfSimulatorDoc = this.firestore.doc(`AanwerfSimulator/${id}`);
    this.aanwerfSimulatorDoc.delete();
  }
}
